// @ts-strict-ignore
import * as BookmarkTypes from 'common/types/reports/bookmark';
import {Section} from 'common/components/items-menu/types';

export type MultiAttributionWeights = BookmarkTypes.MultiAttributionWeights;

export type CustomMultiAttribution = BookmarkTypes.CustomMultiAttribution;

export type PredefinedMultiAttribution = BookmarkTypes.PredefinedMultiAttribution;

export const FreePlanAllowedMultiAttributionTypes = [
  BookmarkTypes.MultiAttributionType.LastTouch,
  BookmarkTypes.MultiAttributionType.FirstTouch,
];

// This is the order they'll appear in the dropdown menu
export const MultiAttributionTypeList = [
  BookmarkTypes.MultiAttributionType.LastTouch,
  BookmarkTypes.MultiAttributionType.FirstTouch,
  BookmarkTypes.MultiAttributionType.Participation,
  BookmarkTypes.MultiAttributionType.TimeDecay,
  BookmarkTypes.MultiAttributionType.Linear,
  BookmarkTypes.MultiAttributionType.UShaped,
  BookmarkTypes.MultiAttributionType.JShaped,
  BookmarkTypes.MultiAttributionType.InverseJShaped,
  BookmarkTypes.MultiAttributionType.Custom,
];

export type MultiAttribution = PredefinedMultiAttribution | CustomMultiAttribution;

export const RemoveAttributionValue = `remove_attribution`;

export type MultiAttributionMenuValue = BookmarkTypes.MultiAttributionType | typeof RemoveAttributionValue;
export type MultiAttributionSection = Section<MultiAttributionMenuValue>;
export type MultiAttributionSectionItem = MultiAttributionSection[`items`][number];
